import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import { adminGamesApi } from '../services/api/adminGamesApi';
import { adminPromoApi } from '../services/api/adminPromoApi';
import { charactersApi } from '../services/api/charactersApi';
import { cpaApi } from '../services/api/cpaApi';
import { dialogsApi } from '../services/api/dialogsApi';
import { featureFlagsApi } from '../services/api/featureFlagsApi';
import { gamesApi } from '../services/api/gamesApi';
import { generateScenarioApi } from '../services/api/generateScenarioApi';
import { mediaPacksApi } from '../services/api/mediaPacksApi';
import { serviceApi } from '../services/api/serviceApi';
import { storageApi } from '../services/api/storageApi';
import { subscribeApi } from '../services/api/subscribeApi';
import { tagApi } from '../services/api/tagApi';
import { tagsCategoriesApi } from '../services/api/tagCategoriesApi';
import { tagsApi } from '../services/api/tagsApi';
import { tokenApi } from '../services/api/tokenApi';
import { userApi } from '../services/api/userApi';
import ScenariosReducer from './DEPRECATEDscenarios/index.js';
import sseReducer from './slices/sseSlice';
import UsersReducer from './DEPRECATEDusers';
import PrivateScenarioSlice from './privateScenario';
import PublicScenarioSlice from './publicScenario';

const rootReducer = combineReducers({
  publicScenario: PublicScenarioSlice,
  privateScenario: PrivateScenarioSlice,
  users: UsersReducer,
  scenarios: ScenariosReducer,
  sse: sseReducer,
  // auto-reducer
  [charactersApi.reducerPath]: charactersApi.reducer,
  [tagApi.reducerPath]: tagApi.reducer,
  [tagsApi.reducerPath]: tagsApi.reducer,
  [tagsCategoriesApi.reducerPath]: tagsCategoriesApi.reducer,
  [generateScenarioApi.reducerPath]: generateScenarioApi.reducer,
  [gamesApi.reducerPath]: gamesApi.reducer,
  [dialogsApi.reducerPath]: dialogsApi.reducer,
  [serviceApi.reducerPath]: serviceApi.reducer,
  [adminGamesApi.reducerPath]: adminGamesApi.reducer,
  [adminPromoApi.reducerPath]: adminPromoApi.reducer,
  [subscribeApi.reducerPath]: subscribeApi.reducer,
  [cpaApi.reducerPath]: cpaApi.reducer,
  [tokenApi.reducerPath]: tokenApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [mediaPacksApi.reducerPath]: mediaPacksApi.reducer,
  [featureFlagsApi.reducerPath]: featureFlagsApi.reducer,
  [storageApi.reducerPath]: storageApi.reducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat(
      // auto-middleware
      charactersApi.middleware,
      tagApi.middleware,
      tagsApi.middleware,
      tagsCategoriesApi.middleware,
      generateScenarioApi.middleware,
      dialogsApi.middleware,
      gamesApi.middleware,
      serviceApi.middleware,
      adminGamesApi.middleware,
      adminPromoApi.middleware,
      subscribeApi.middleware,
      cpaApi.middleware,
      tokenApi.middleware,
      userApi.middleware,
      mediaPacksApi.middleware,
      featureFlagsApi.middleware,
      storageApi.middleware,
    ),
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
